import { api } from '../lib/api'

export type TelemetryRequestRow = {
  id: number
  created_at: string
  method: string
  path: string
  status: number
  duration_ms: number
  user_id: number | null
  actor_handle: string
  client_session_id: string
  client_flow_id: string
  client_request_id: string
  request_id: string
}

export type TelemetryEventRow = {
  id: number
  created_at: string
  event_type: string
  severity: 'info' | 'warn' | 'error' | string
  user_id: number | null
  actor_handle: string
  client_session_id: string
  client_flow_id: string
  client_request_id: string
  request_id: string
  target_type: string
  target_id: string
  message: string
  meta: Record<string, unknown>
}

export type TelemetryListResponse<T> = {
  results: T[]
  next_cursor: number | null
}

type QueryValue = string | number | null | undefined

function toQuery(params: Record<string, QueryValue>): string {
  const sp = new URLSearchParams()
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return
    sp.set(key, String(value))
  })
  const qs = sp.toString()
  return qs ? `?${qs}` : ''
}

export async function listTelemetryRequests(params: Record<string, QueryValue> = {}) {
  const { data } = await api.get<TelemetryListResponse<TelemetryRequestRow>>(
    `/api/admin/telemetry/requests/${toQuery(params)}`
  )
  return data
}

export async function listTelemetryEvents(params: Record<string, QueryValue> = {}) {
  const { data } = await api.get<TelemetryListResponse<TelemetryEventRow>>(
    `/api/admin/telemetry/events/${toQuery(params)}`
  )
  return data
}

export async function getTelemetryTrace(params: Record<string, QueryValue>) {
  const { data } = await api.get<{ requests: TelemetryRequestRow[]; events: TelemetryEventRow[] }>(
    `/api/admin/telemetry/trace/${toQuery(params)}`
  )
  return data
}

